/**
 * Pocket Radar surface descriptor — feeds into renderSessionSurface (src/ui/session-surface.js).
 *
 * Mirrors rapsodo/surface.js. Two differences:
 *   - No compare button (PR section doesn't render one).
 *   - One detail chart (ta-pr-trend) vs Rapsodo's two.
 */

import { aggregatePocketRadarSessions } from '../../db/aggregation.js';
import { deletePocketRadarSession } from '../../db/queries.js';

export const pocketRadarSurface = {
  sectionId: '#pr-section',
  tableId: '#pr-sessions-table',
  chartWrapId: '#pr-sessions-chart-wrap',
  pickerId: '#pr-session-picker',
  detailId: '#pr-detail',
  detailSubId: '#pr-detail-sub',

  // No compareButtonId — PR section doesn't have one.

  chartKind: 'pocket-radar',

  detailCharts: [
    { containerId: '#athlete-pr-trend', tag: 'ta-pr-trend', rowsProp: 'throws' },
  ],

  aggregate: aggregatePocketRadarSessions,
  deleteSession: deletePocketRadarSession,

  detailLabel: (session) => `${session.label} — per-throw detail`,
  detailFallbackLabel: 'Per-throw detail',
  deleteConfirmCopy: (label) =>
    `Delete "${label}"?\n\n` +
    `This permanently removes the Pocket Radar upload, every throw in it, ` +
    `the archived CSV, and the Files-tab entry. This can't be undone.`,
};
